"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="grid min-h-screen place-items-center px-5">
      <section className="card-surface w-full max-w-lg rounded-[var(--radius-card)] p-7 text-center">
        <p className="eyebrow">请求未完成</p>
        <h1 className="mt-3 text-2xl font-semibold">页面遇到了意外问题</h1>
        <p className="mt-3 text-sm text-[var(--color-muted)]">
          数据没有被静默忽略。你可以重试，或返回控制台确认当前状态。
        </p>
        {error.digest && (
          <p className="mt-3 font-mono text-xs text-[var(--color-faint)]">错误编号：{error.digest}</p>
        )}
        <div className="mt-6 flex justify-center gap-3">
          <button onClick={reset} className="btn-silver rounded-full px-4 py-2">重试</button>
          <Link href="/dashboard" className="chip rounded-full px-4 py-2">返回控制台</Link>
        </div>
      </section>
    </main>
  );
}
